import { shallowRef } from 'vue';
import { apiRequest } from '@/api/http';

// The signed-in user's photo URL, shared by the sidebar's user menu and
// Settings › Profile so a new upload shows everywhere at once. Empty when
// the user has no photo of their own (the menu then shows their initials).
export const DEFAULT_AVATAR = 'img_avatar.png';
const url = shallowRef('');

function toUrl(filename, bust = false) {
  if (!filename || filename === DEFAULT_AVATAR) return '';
  const base = `${process.env.VUE_APP_SERVER}/user-details/getProfileImg/${encodeURIComponent(filename)}`;
  return bust ? `${base}?v=${Date.now()}` : base;
}

// Re-reads the photo from the server; pass bust after an upload in case the
// server reuses the file name.
async function refresh({ bust = false } = {}) {
  try {
    const data = await apiRequest('get', '/user-details/getUserProfileImg');
    url.value = toUrl(data?.profile_img, bust);
  } catch {
    // Keep what's shown; the initials fallback covers a missing photo.
  }
}

export function useProfilePhoto() {
  return { url, refresh };
}
